import { createContext } from "react"

export interface Config {
  CU_URL: string
  MU_URL: string
  GATEWAY_URL: string
}

export const defaultConfig: Config = {
  CU_URL: "https://cu-af.dataos.so",
  MU_URL: "https://mu.ao-testnet.xyz",
  GATEWAY_URL: "https://arweave.net:443",
}

export const ConfigContext = createContext<[Config, (val: Config) => void]>([] as any)

export const STORAGE_KEY = "APP_CONFIG"

export interface Gateway {
  host: string
  port: string
  protocol: string
}
